
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import MicrosoftSignInButton from './MicrosoftSignInButton';
import EmailSignInForm from './EmailSignInForm';
import { useLanguage } from '@/hooks/useLanguage';

interface AuthCardProps {
  loading: boolean;
  error: string | null;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

const AuthCard = ({ 
  loading, 
  error, 
  setLoading, 
  setError 
}: AuthCardProps) => {
  const { translate } = useLanguage();
  
  // Helper function to display user-friendly error messages
  const getErrorMessage = (errorMessage: string) => {
    if (errorMessage.includes('Invalid login credentials')) {
      return 'Invalid email or password. Please try again.';
    }
    return errorMessage;
  };

  return (
    <Card className="w-full max-w-md">
      <CardHeader className="space-y-4">
        <CardTitle className="text-2xl font-bold text-center">
          {translate('auth.welcome')}
        </CardTitle>
        <CardDescription className="text-center">
          {translate('auth.subtitle')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {error && (
          <Alert variant="destructive">
            <AlertDescription>{getErrorMessage(error)}</AlertDescription>
          </Alert>
        )}
        
        <MicrosoftSignInButton 
          loading={loading} 
          setLoading={setLoading} 
          setError={setError} 
        />

        <div className="relative my-4">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-border"></div>
          </div>
          <div className="relative flex justify-center text-xs uppercase">
            <span className="bg-card px-2 text-muted-foreground">{translate('auth.orContinueWithEmail')}</span>
          </div>
        </div>

        <EmailSignInForm 
          loading={loading} 
          setLoading={setLoading} 
          setError={setError} 
        />
      </CardContent>
    </Card>
  );
};

export default AuthCard;
